import { createFileRoute } from "@tanstack/react-router";

import { MorrowUsageAnalytics } from "../components/usage/MorrowUsageAnalytics";

// A faithful copy of the T3 usage LAYOUT (same sections/graph/metric grid),
// fed by REAL MorrowOS data: plan access/limits + the actual models the agent
// ran, priced at full API rate. Models are generic, so the T3 provider marks
// are replaced with a per-model colour.
export const Route = createFileRoute("/usage")({
  component: MorrowUsageAnalytics,
});
